import { SilverwareIcon } from './SilverwareIcon';

/**
 * author: Google
 * id F7C26535-863F-4295-9E48-9847B740FEE7
 * name silverware
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware.svg
 * tags
 * - Food / Drink 
 */
export const LocalDiningIcon = SilverwareIcon;
export default LocalDiningIcon